import React from "react";
import {Text} from "../../../../ui";
import {Link} from "../../../bounce-ui";
import {Box} from "@mui/material";

interface IDisputeLinks {
  handleVerificationRequest: () => void;
  handleFileDispute: () => void;
}

export const DisputeLinks = ({handleVerificationRequest, handleFileDispute}: IDisputeLinks) => {
  return (
    <Box sx={{width: "100%"}}>
      <Text size={14} fontWeight={500} sx={{textAlign: "left"}}>
        Something looks off? make a
      </Text>
      <Link onClick={handleVerificationRequest} size={14}>
        Verification request
      </Link>
      &nbsp;or{" "}
      <Link onClick={handleFileDispute} size={14}>
        File a Dispute
      </Link>
    </Box>
  );
};
